;(function ($) {
    var pluginName = 'twn-filter';
    var defaults = {
        key: "value"
    };

    var initSelector = '.js-filter';


    function Filter(element, options) {
        this.$filter = $(element);
        this.options = $.extend({}, defaults, options, this.$filter.data());
        this._defaults = defaults;
        this._name = pluginName;
        this.targets = [];
        this.visibleAll = true;

        this.init();
    }

    Filter.prototype.init = function () {
        // targets
        var targets = this.$filter.find("[data-target]");

        for (var i = 0; i < targets.length; i++) {
            var $target = $(targets[i]);
            var target = $target.data("target");

            if (!target) {
                continue;
            }

            this.initFilterButton($target);
        }
    };

    Filter.prototype.initFilterButton = function ($filterButton) {
        var _that = this;
        var targetSelector = $filterButton.data("target");

        //bid click event
        $filterButton.on("click", function (event) {
            event.stopPropagation();
            _that.toggle(targetSelector);
        });

        if (targetSelector == "all") {
            $filterButton.addClass("is-active");
            this.$masterButton = $filterButton;

            return;
        }

        $(targetSelector).collapse();
        this.targets.push(targetSelector);
    };


    /* Filter toggle rules */
    Filter.prototype.toggle = function (trigger) {

        if (trigger === "all") {
            this.visibleAll ? this.hideAll() : this.showAll();
        } else if (this.visibleAll) {
            this.hideAll(trigger);

            // this.hideAll(function () {
            //     $(trigger).collapse("show");
            // });
        } else {
            $(trigger).collapse("toggle");
        }
    };

    Filter.prototype.showAll = function () {
        for (var i = 0; i < this.targets.length; i++) {
            $(this.targets[i]).collapse("show");
        }
        this.visibleAll = true;
        this.setStyle()
    };

    Filter.prototype.hideAll = function (exept) {
        var open = this.targets.length;

        for (var i = 0; i < this.targets.length; i++) {

            if( this.targets[i] != exept) {
                $(this.targets[i]).collapse("hide");
            }
        }

        this.visibleAll = false;
        this.setStyle();

    };


    Filter.prototype.setStyle = function () {
        if (this.visibleAll) {
            this.$masterButton.addClass("is-active");
            this.$filter.addClass("filter--all");
        } else {
            this.$masterButton.removeClass("is-active");
            this.$filter.removeClass("filter--all");
        }
    };

    /**
     * Destroy the plugin instance
     * @method destroy
     * @returns {void}
     */
    Filter.prototype.destroy = function () {
        $(this.$filter[0]).removeData('plugin_' + pluginName);
    };

    /**
     * Create jQuery plugin.
     * @param {Object} options Extended options
     * @listens rkas.filter
     * @returns {Array<Filter>} Array of Maps
     */
    $.fn[pluginName] = function (options) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function () {
            var instance = $.data(this, 'plugin_' + pluginName);

            if (!instance) {
                if (options === 'destroy') {
                    return;
                }

                $.data(this, 'plugin_' + pluginName, new Filter(this, options));
            } else if (typeof options === 'string') {
                instance[options].apply(instance, args);
            }
        });
    };

    /**
     * @event enhance.twn.filter
     * @param   {Event} event
     */
    $(document).on('enhance.twn.filter', function (event) {
        // debugger;
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]();
    });

    /**
     * @event destroy.twn.filter
     * @param   {Event} event
     */
    $(document).on('destroy.twn.filter', function (event) {
        $(event.target).find(initSelector).addBack(initSelector)[pluginName]('destroy');
    });

    /**
     * Auto-init the plugin on DOM ready.
     * @fires enhance.twn.filter
     */
    $(function () {
        $(document).trigger('enhance.twn.filter');
    });
}(jQuery));

